export default __webpack_public_path__ + "vuejs.dbef4b04.png";